// extracted by mini-css-extract-plugin
export default {"change-owner-text":"change-owner__change-owner-text--g27Wj","changeOwnerText":"change-owner__change-owner-text--g27Wj"};